
    import './assets/index-26535c63.js';

    const overlay = document.getElementById('loading-overlay');
    const canvas = document.getElementById('particle-canvas');

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    class Particle {
      constructor({ x, y, targetX, targetY, size, color, isBackground = false }) {
        this.x = x ?? Math.random() * window.innerWidth;
        this.y = y ?? Math.random() * window.innerHeight;
        this.targetX = targetX ?? x ?? this.x;
        this.targetY = targetY ?? y ?? this.y;

        this.vx = 0;
        this.vy = 0;

        this.size = size;
        this.baseSize = size;
        this.color = color;
        this.isBackground = isBackground;
        this.explosionBoost = 0.6 + Math.random() * 1.6;

        // Physics Params
        this.friction = 0.90 + Math.random() * 0.05;
        this.springFactor = 0.05 + Math.random() * 0.05;

        // Background particles rise up (Ember effect)
        if (isBackground) {
          this.vy = -0.5 - Math.random() * 1.5; // Upward velocity
          this.vx = (Math.random() - 0.5) * 0.5; // Slight horizontal drift
          this.friction = 1; // Constant speed
          this.springFactor = 0; // No spring
        }

        this.opacity = 0;
        this.fadeInSpeed = 0.01 + Math.random() * 0.02;
      }

      update(mouse, dispersing) {
        if (dispersing) {
          // Explosion logic
          const dx = this.x - window.innerWidth / 2;
          const dy = this.y - window.innerHeight / 2;
          const dist = Math.sqrt(dx * dx + dy * dy) || 1;

          const force = (800 / dist) * this.explosionBoost;
          this.vx += (dx / dist) * force;
          this.vy += (dy / dist) * force;

          this.vx *= 0.98;
          this.vy *= 0.98;
          this.opacity -= 0.03;

          this.x += this.vx;
          this.y += this.vy;
        } else {
          if (this.isBackground) {
            // Rising behavior
            this.y += this.vy;
            this.x += this.vx;

            // Wrap around screen
            if (this.y < -10) {
              this.y = window.innerHeight + 10;
              this.x = Math.random() * window.innerWidth;
            }

            // Mouse Interaction for background (subtle push)
            const mdx = this.x - mouse.x;
            const mdy = this.y - mouse.y;
            const mDist = Math.sqrt(mdx * mdx + mdy * mdy);
            if (mDist < 150) {
              const force = (150 - mDist) * 0.002;
              this.vx += mdx * force;
              // this.vy += mdy * force; // optional: vertical push
            }

          } else {
            // Text Particle Logic (Spring + Strong Mouse Repulsion)
            const dx = this.targetX - this.x;
            const dy = this.targetY - this.y;

            this.vx += dx * this.springFactor;
            this.vy += dy * this.springFactor;

            // Mouse Repulsion
            const mdx = this.x - mouse.x;
            const mdy = this.y - mouse.y;
            const mDist = Math.sqrt(mdx * mdx + mdy * mdy);

            if (mDist < 100) {
              const force = (100 - mDist) * 2;
              this.vx += (mdx / mDist) * force;
              this.vy += (mdy / mDist) * force;
            }

            this.vx *= this.friction;
            this.vy *= this.friction;

            this.x += this.vx;
            this.y += this.vy;
          }

          this.opacity = Math.min(this.opacity + this.fadeInSpeed, 1);
        }
      }

      draw(ctx) {
        if (this.opacity <= 0.01) return;
        ctx.globalAlpha = this.opacity;
        ctx.fillStyle = this.color;

        // Background sparks can be smaller/fainter
        const s = this.isBackground ? this.size * 0.8 : this.size;

        ctx.beginPath();
        ctx.arc(this.x, this.y, s, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function createParticleLoader() {
      const ctx = canvas.getContext('2d');
      if (!ctx) return null;

      let particles = [];
      const mouse = { x: -9999, y: -9999 };
      let userHasMovedMouse = false;
      let dispersing = false;
      let rafId;
      const startedAt = performance.now();

      const AUTO_MOUSE_DELAY_MS = 700;

      const palette = [
        '#ffffff',
        '#cfb53b',
        '#ff4d00',
      ];

      function initParticles() {
        particles = [];

        // Scan Text
        const fontSize = Math.min(window.innerWidth / 10, 80);
        ctx.font = `300 ${fontSize}px system-ui, sans-serif`;
        ctx.fillStyle = 'white';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        const cx = canvas.width / 2;
        const cy = canvas.height / 2;

        ctx.fillText("Project loading...", cx, cy);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        const gap = 3; // Dense

        for (let y = 0; y < canvas.height; y += gap) {
          for (let x = 0; x < canvas.width; x += gap) {
            const idx = (y * canvas.width + x) * 4;
            if (data[idx + 3] > 128) {
              const angle = Math.random() * Math.PI * 2;
              // Smaller spawn circle on mobile
              const isMobile = canvas.width < 768;
              const maxRadiusMult = isMobile ? 0.10 : 0.35;
              const minRadiusMult = isMobile ? 0.03 : 0.12;
              const maxRadius = Math.min(canvas.width, canvas.height) * maxRadiusMult;
              const minRadius = Math.min(canvas.width, canvas.height) * minRadiusMult;
              const radius = minRadius + Math.random() * (maxRadius - minRadius);
              const startX = cx + Math.cos(angle) * radius;
              const startY = cy + Math.sin(angle) * radius;

              const p = new Particle({
                x: startX,
                y: startY,
                targetX: x,
                targetY: y,
                // Smaller text particles: 0.4 to 1.3
                size: Math.random() * 0.9 + 0.4,
                color: palette[Math.floor(Math.random() * palette.length)]
              });
              particles.push(p);
            }
          }
        }

        // Background particles (Rising Sparks)
        // Increased count slightly for effect
        for (let i = 0; i < 400; i++) {
          const p = new Particle({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            size: Math.random() * 1.5 + 0.5,
            color: palette[Math.floor(Math.random() * palette.length)], // Multi-colored sparks
            isBackground: true
          });
          particles.push(p);
        }
      }

      function onResize() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        initParticles();
      }

      function onMouseMove(e) {
        userHasMovedMouse = true;
        mouse.x = e.clientX;
        mouse.y = e.clientY;
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.globalCompositeOperation = 'lighter'; // Glow effect

        if (!dispersing && !userHasMovedMouse) {
          const elapsed = performance.now() - startedAt;
          if (elapsed > AUTO_MOUSE_DELAY_MS) {
            const t = (elapsed - AUTO_MOUSE_DELAY_MS) / 1000;
            // Smaller circle on mobile
            const isMobile = canvas.width < 768;
            const radiusMult = isMobile ? 0.01 : 0.08;
            const radius = Math.min(canvas.width, canvas.height) * radiusMult;
            mouse.x = canvas.width / 2 + Math.cos(t * 1.35) * radius;
            mouse.y = canvas.height / 2 + Math.sin(t * 1.7) * radius;
          }
        }

        for (let i = 0; i < particles.length; i++) {
          particles[i].update(mouse, dispersing);
          particles[i].draw(ctx);
        }

        ctx.globalCompositeOperation = 'source-over';

        if (!dispersing || particles.some(p => p.opacity > 0.01)) {
          rafId = requestAnimationFrame(animate);
        } else {
          overlay.remove();
        }
      }

      function start() {
        window.addEventListener('resize', onResize);
        window.addEventListener('mousemove', onMouseMove);
        onResize();
        animate();
      }

      function disperse() {
        dispersing = true;
        overlay.style.opacity = '0'; // helper fade
      }

      return { start, disperse };
    }

    const loader = createParticleLoader();
    if (loader) loader.start();
    else overlay.classList.add('is-fallback');

    // Wait until Three.js finishes loading assets
    const READY_TIMEOUT_MS = 120000;
    const DISPERSE_DELAY_MS = 700;

    let didFinish = false;
    let hardTimeoutId;

    const finishLoading = () => {
      if (didFinish) return;
      didFinish = true;
      if (hardTimeoutId) clearTimeout(hardTimeoutId);

      overlay.classList.add('is-exiting');

      setTimeout(() => {
        if (loader) loader.disperse();
        else overlay.remove();

        // Patches
        if (window.scene) {
          window.scene.traverse((child) => {
            if (child.isMesh && child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach(mat => { mat.side = 2; });
              } else {
                child.material.side = 2;
              }
            }
          });
        }
      }, DISPERSE_DELAY_MS);
    };

    if (window.__kilpiReady) {
      finishLoading();
    } else {
      window.addEventListener('kilpi:ready', finishLoading, { once: true });
      hardTimeoutId = setTimeout(finishLoading, READY_TIMEOUT_MS);
    }

  